
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 6.5.0
 * Query Engine version: 173f8d54f8d52e692c7e27e72a88314ec7aeff60
 */
Prisma.prismaVersion = {
  client: "6.5.0",
  engine: "173f8d54f8d52e692c7e27e72a88314ec7aeff60"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  email: 'email',
  password: 'password',
  firstName: 'firstName',
  lastName: 'lastName',
  phoneNumber: 'phoneNumber',
  role: 'role',
  isVerified: 'isVerified',
  verificationCode: 'verificationCode',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AddressScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  other: 'other',
  street: 'street',
  number: 'number',
  city: 'city',
  state: 'state',
  officeCode: 'officeCode',
  postalCode: 'postalCode',
  country: 'country',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ActivityScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  action: 'action',
  target: 'target',
  targetId: 'targetId',
  ipAddress: 'ipAddress',
  userAgent: 'userAgent',
  createdAt: 'createdAt'
};

exports.Prisma.NotificationScalarFieldEnum = {
  id: 'id',
  message: 'message',
  type: 'type',
  notificationDeliveryMethod: 'notificationDeliveryMethod',
  createdAt: 'createdAt'
};

exports.Prisma.AdminNotificationScalarFieldEnum = {
  id: 'id',
  adminId: 'adminId',
  notificationId: 'notificationId',
  orderId: 'orderId',
  isRead: 'isRead'
};

exports.Prisma.OrderScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  shippingAddressId: 'shippingAddressId',
  billingAddressId: 'billingAddressId',
  paymentId: 'paymentId',
  subscriptionId: 'subscriptionId',
  status: 'status',
  totalAmount: 'totalAmount',
  discountCode: 'discountCode',
  discountType: 'discountType',
  discountValue: 'discountValue',
  orderNumber: 'orderNumber',
  deliveryCourier: 'deliveryCourier',
  deliveryMethod: 'deliveryMethod',
  deliveryOffice: 'deliveryOffice',
  deliveryCity: 'deliveryCity',
  paymentMethod: 'paymentMethod',
  notes: 'notes',
  firstName: 'firstName',
  lastName: 'lastName',
  phoneNumber: 'phoneNumber',
  email: 'email',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  waybill: 'waybill'
};

exports.Prisma.OrderItemScalarFieldEnum = {
  id: 'id',
  orderId: 'orderId',
  productId: 'productId',
  variantId: 'variantId',
  quantity: 'quantity',
  personalization: 'personalization',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  unitPrice: 'unitPrice',
  totalPrice: 'totalPrice'
};

exports.Prisma.OrderItemAttributeValueScalarFieldEnum = {
  id: 'id',
  orderItemId: 'orderItemId',
  attributeId: 'attributeId',
  attributeValueId: 'attributeValueId',
  value: 'value'
};

exports.Prisma.CartScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CartItemScalarFieldEnum = {
  id: 'id',
  cartId: 'cartId',
  productId: 'productId',
  variantId: 'variantId',
  quantity: 'quantity',
  addedAt: 'addedAt',
  personalization: 'personalization'
};

exports.Prisma.CartItemAttributeValueScalarFieldEnum = {
  id: 'id',
  cartItemId: 'cartItemId',
  attributeId: 'attributeId',
  attributeValueId: 'attributeValueId',
  value: 'value'
};

exports.Prisma.PaymentScalarFieldEnum = {
  id: 'id',
  orderId: 'orderId',
  subtotal: 'subtotal',
  discount: 'discount',
  shippingFee: 'shippingFee',
  tax: 'tax',
  totalAmount: 'totalAmount',
  method: 'method',
  status: 'status',
  transactionId: 'transactionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.WebsiteSettingsScalarFieldEnum = {
  id: 'id',
  twoFactorAuth: 'twoFactorAuth',
  enableRegistration: 'enableRegistration',
  emailNotifications: 'emailNotifications',
  smsNotifications: 'smsNotifications',
  notificationEmail: 'notificationEmail',
  allowGuestCheckout: 'allowGuestCheckout',
  shippingCostBasedOnLocation: 'shippingCostBasedOnLocation',
  defaultShippingCost: 'defaultShippingCost',
  freeShippingThreshold: 'freeShippingThreshold',
  enableProductReviews: 'enableProductReviews',
  allowProductCustomization: 'allowProductCustomization',
  enableDiscountCodes: 'enableDiscountCodes',
  lowStockThreshold: 'lowStockThreshold',
  enableBackOrders: 'enableBackOrders',
  googleAnalyticsId: 'googleAnalyticsId',
  facebookPixelId: 'facebookPixelId',
  hotjarId: 'hotjarId'
};

exports.Prisma.ProductScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  description: 'description',
  shortDescription: 'shortDescription',
  sku: 'sku',
  barcode: 'barcode',
  price: 'price',
  salePrice: 'salePrice',
  minPrice: 'minPrice',
  maxPrice: 'maxPrice',
  stockQuantity: 'stockQuantity',
  stockStatus: 'stockStatus',
  weight: 'weight',
  width: 'width',
  height: 'height',
  length: 'length',
  tags: 'tags',
  isSubscribable: 'isSubscribable',
  avgRating: 'avgRating',
  totalReviews: 'totalReviews',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  isPopular: 'isPopular',
  metaTitle: 'metaTitle',
  metaDescription: 'metaDescription',
  metaKeywords: 'metaKeywords',
  returnPolicy: 'returnPolicy',
  warranty: 'warranty',
  minOrderQuantity: 'minOrderQuantity',
  animalType: 'animalType',
  suitableBreeds: 'suitableBreeds',
  ageGroup: 'ageGroup',
  weightRangeMin: 'weightRangeMin',
  weightRangeMax: 'weightRangeMax',
  ingredients: 'ingredients',
  nutritionalInfo: 'nutritionalInfo',
  usageInstructions: 'usageInstructions',
  dosage: 'dosage',
  indications: 'indications',
  contraindications: 'contraindications',
  sideEffects: 'sideEffects',
  regulatoryApproval: 'regulatoryApproval',
  material: 'material',
  safetyInformation: 'safetyInformation',
  allergens: 'allergens',
  sensitivityNotes: 'sensitivityNotes',
  expirationDate: 'expirationDate',
  shelfLifeMonths: 'shelfLifeMonths',
  storageConditions: 'storageConditions',
  vetRecommended: 'vetRecommended',
  prescriptionRequired: 'prescriptionRequired',
  cogs: 'cogs',
  personalizedTags: 'personalizedTags'
};

exports.Prisma.ProductCategoryScalarFieldEnum = {
  id: 'id',
  productId: 'productId',
  categoryId: 'categoryId'
};

exports.Prisma.VariantScalarFieldEnum = {
  id: 'id',
  name: 'name',
  sku: 'sku',
  slug: 'slug',
  price: 'price',
  salePrice: 'salePrice',
  stockQuantity: 'stockQuantity',
  stockStatus: 'stockStatus',
  productId: 'productId',
  metaTitle: 'metaTitle',
  metaDescription: 'metaDescription',
  cogs: 'cogs',
  weight: 'weight',
  width: 'width',
  height: 'height',
  length: 'length'
};

exports.Prisma.AttributeScalarFieldEnum = {
  id: 'id',
  name: 'name',
  type: 'type',
  isRequired: 'isRequired',
  productId: 'productId',
  variantId: 'variantId',
  parentAttributeId: 'parentAttributeId'
};

exports.Prisma.AttributeValueScalarFieldEnum = {
  id: 'id',
  value: 'value',
  label: 'label',
  placeholder: 'placeholder',
  minLength: 'minLength',
  maxLength: 'maxLength',
  minValue: 'minValue',
  maxValue: 'maxValue',
  useSlider: 'useSlider',
  priceAdjustment: 'priceAdjustment',
  attributeId: 'attributeId'
};

exports.Prisma.ImageScalarFieldEnum = {
  id: 'id',
  url: 'url',
  altText: 'altText',
  order: 'order',
  productId: 'productId',
  variantId: 'variantId',
  categoryId: 'categoryId'
};

exports.Prisma.VideoScalarFieldEnum = {
  id: 'id',
  url: 'url',
  productId: 'productId'
};

exports.Prisma.RatingScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  rating: 'rating',
  firstName: 'firstName',
  lastName: 'lastName',
  review: 'review',
  productId: 'productId',
  createdAt: 'createdAt',
  status: 'status'
};

exports.Prisma.QuestionScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  question: 'question',
  answer: 'answer',
  productId: 'productId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BulkDiscountScalarFieldEnum = {
  id: 'id',
  minQuantity: 'minQuantity',
  discount: 'discount',
  productId: 'productId'
};

exports.Prisma.RegionalPricingScalarFieldEnum = {
  id: 'id',
  region: 'region',
  price: 'price',
  salePrice: 'salePrice',
  productId: 'productId',
  variantId: 'variantId'
};

exports.Prisma.RegionalAvailabilityScalarFieldEnum = {
  id: 'id',
  region: 'region',
  releaseDate: 'releaseDate',
  availabilityDate: 'availabilityDate',
  productId: 'productId'
};

exports.Prisma.ComplianceScalarFieldEnum = {
  id: 'id',
  regulation: 'regulation',
  complianceCode: 'complianceCode',
  productId: 'productId'
};

exports.Prisma.BundleScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  totalPrice: 'totalPrice',
  productId: 'productId',
  stockStatus: 'stockStatus'
};

exports.Prisma.BundleItemScalarFieldEnum = {
  id: 'id',
  bundleId: 'bundleId',
  productId: 'productId',
  quantity: 'quantity',
  priceAdjustment: 'priceAdjustment'
};

exports.Prisma.PriceHistoryScalarFieldEnum = {
  id: 'id',
  price: 'price',
  salePrice: 'salePrice',
  startDate: 'startDate',
  endDate: 'endDate',
  productId: 'productId',
  variantId: 'variantId'
};

exports.Prisma.MediaScalarFieldEnum = {
  id: 'id',
  type: 'type',
  url: 'url',
  altText: 'altText',
  productId: 'productId',
  ratingId: 'ratingId',
  supportDocumentId: 'supportDocumentId'
};

exports.Prisma.SupportDocumentScalarFieldEnum = {
  id: 'id',
  productId: 'productId',
  title: 'title',
  url: 'url',
  type: 'type'
};

exports.Prisma.DiscountCodeScalarFieldEnum = {
  id: 'id',
  code: 'code',
  description: 'description',
  discountType: 'discountType',
  discountValue: 'discountValue',
  startDate: 'startDate',
  endDate: 'endDate',
  usageLimit: 'usageLimit',
  usedCount: 'usedCount'
};

exports.Prisma.ProductFlagScalarFieldEnum = {
  id: 'id',
  flagType: 'flagType',
  description: 'description'
};

exports.Prisma.ProductFlagProductScalarFieldEnum = {
  id: 'id',
  productId: 'productId',
  productFlagId: 'productFlagId'
};

exports.Prisma.RecommendedProductScalarFieldEnum = {
  id: 'id',
  productId: 'productId',
  recommendedId: 'recommendedId'
};

exports.Prisma.WishlistScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.WishlistItemScalarFieldEnum = {
  id: 'id',
  wishlistId: 'wishlistId',
  productId: 'productId',
  addedAt: 'addedAt'
};

exports.Prisma.BundleRuleScalarFieldEnum = {
  id: 'id',
  bundleId: 'bundleId',
  ruleType: 'ruleType',
  value: 'value'
};

exports.Prisma.CrossBorderConstraintScalarFieldEnum = {
  id: 'id',
  productId: 'productId',
  region: 'region',
  reason: 'reason'
};

exports.Prisma.ProductDiscountScalarFieldEnum = {
  id: 'id',
  productId: 'productId',
  discountCodeId: 'discountCodeId'
};

exports.Prisma.CategoryScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  parentId: 'parentId',
  image: 'image'
};

exports.Prisma.PopularityScalarFieldEnum = {
  id: 'id',
  productId: 'productId',
  views: 'views',
  purchases: 'purchases',
  addedToCart: 'addedToCart',
  wishlist: 'wishlist',
  score: 'score',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PopularSectionScalarFieldEnum = {
  id: 'id',
  title: 'title',
  description: 'description',
  position: 'position',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PopularSectionProductScalarFieldEnum = {
  id: 'id',
  sectionId: 'sectionId',
  productId: 'productId',
  createdAt: 'createdAt'
};

exports.Prisma.AutomationRuleScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  isActive: 'isActive',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AutomationEventTriggerScalarFieldEnum = {
  id: 'id',
  ruleId: 'ruleId',
  event: 'event'
};

exports.Prisma.AutomationConditionScalarFieldEnum = {
  id: 'id',
  ruleId: 'ruleId',
  field: 'field',
  operator: 'operator',
  value: 'value'
};

exports.Prisma.AutomationActionScalarFieldEnum = {
  id: 'id',
  ruleId: 'ruleId',
  type: 'type'
};

exports.Prisma.AutomationActionParameterScalarFieldEnum = {
  id: 'id',
  actionId: 'actionId',
  key: 'key',
  value: 'value'
};

exports.Prisma.ScheduledAutomationScalarFieldEnum = {
  id: 'id',
  ruleId: 'ruleId',
  frequency: 'frequency',
  nextRunAt: 'nextRunAt',
  isActive: 'isActive',
  customCronExpression: 'customCronExpression'
};

exports.Prisma.MarketingPreferenceScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  subscribed: 'subscribed'
};

exports.Prisma.BrandScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  image: 'image'
};

exports.Prisma.BankCardScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  cardName: 'cardName',
  cardNumber: 'cardNumber',
  expiryMonth: 'expiryMonth',
  expiryYear: 'expiryYear',
  cvv: 'cvv',
  isDefault: 'isDefault',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AutoshipSubscriptionScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  name: 'name',
  status: 'status',
  frequency: 'frequency',
  nextDeliveryDate: 'nextDeliveryDate',
  lastOrderDate: 'lastOrderDate',
  totalOrders: 'totalOrders',
  shippingAddressId: 'shippingAddressId',
  paymentMethod: 'paymentMethod',
  bankCardId: 'bankCardId',
  isPickup: 'isPickup',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AutoshipSubscriptionItemScalarFieldEnum = {
  id: 'id',
  subscriptionId: 'subscriptionId',
  productId: 'productId',
  variantId: 'variantId',
  quantity: 'quantity',
  unitPrice: 'unitPrice',
  totalPrice: 'totalPrice'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};
exports.Role = exports.$Enums.Role = {
  USER: 'USER',
  CUSTOMER: 'CUSTOMER',
  ADMIN: 'ADMIN',
  VENDOR: 'VENDOR'
};

exports.ActivityAction = exports.$Enums.ActivityAction = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  REGISTER: 'REGISTER',
  CREATE: 'CREATE',
  READ: 'READ',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  APPROVE: 'APPROVE',
  REJECT: 'REJECT',
  ADD: 'ADD',
  REMOVE: 'REMOVE',
  CLEAR: 'CLEAR',
  START: 'START',
  COMPLETE: 'COMPLETE',
  CANCEL: 'CANCEL',
  APPLY: 'APPLY',
  REMOVE_APPLIED: 'REMOVE_APPLIED',
  REQUEST: 'REQUEST',
  TRACK: 'TRACK',
  SUBSCRIBE: 'SUBSCRIBE',
  UNSUBSCRIBE: 'UNSUBSCRIBE',
  SEARCH: 'SEARCH',
  BROWSE: 'BROWSE',
  FILTER: 'FILTER',
  RATE: 'RATE',
  REVIEW: 'REVIEW',
  REPORT: 'REPORT',
  CONTACT_SUPPORT: 'CONTACT_SUPPORT',
  USE_CHATBOT: 'USE_CHATBOT',
  VIEW: 'VIEW',
  OTHER: 'OTHER'
};

exports.ActivityTarget = exports.$Enums.ActivityTarget = {
  USER: 'USER',
  PRODUCT: 'PRODUCT',
  ORDER: 'ORDER',
  CATEGORY: 'CATEGORY',
  REVIEW: 'REVIEW',
  CART: 'CART',
  PAYMENT: 'PAYMENT',
  WISHLIST: 'WISHLIST',
  CHECKOUT: 'CHECKOUT',
  DISCOUNT: 'DISCOUNT',
  DELIVERY: 'DELIVERY',
  PROFILE: 'PROFILE',
  NOTIFICATION: 'NOTIFICATION',
  SUPPORT: 'SUPPORT',
  FAQ: 'FAQ',
  CHATBOT: 'CHATBOT',
  SEARCH: 'SEARCH',
  RECOMMENDATION: 'RECOMMENDATION'
};

exports.NotificationType = exports.$Enums.NotificationType = {
  ALERT: 'ALERT',
  REMINDER: 'REMINDER',
  UPDATE: 'UPDATE',
  PROMOTION: 'PROMOTION'
};

exports.NotificationDeliveryMethod = exports.$Enums.NotificationDeliveryMethod = {
  EMAIL: 'EMAIL',
  SMS: 'SMS',
  IN_APP: 'IN_APP'
};

exports.OrderStatus = exports.$Enums.OrderStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  REFUNDED: 'REFUNDED'
};

exports.DiscountType = exports.$Enums.DiscountType = {
  PERCENTAGE: 'PERCENTAGE',
  FIXED: 'FIXED'
};

exports.DeliveryMethod = exports.$Enums.DeliveryMethod = {
  ADDRESS_DELIVERY: 'ADDRESS_DELIVERY',
  OFFICE_DELIVERY: 'OFFICE_DELIVERY',
  DIGITAL_DOWNLOAD: 'DIGITAL_DOWNLOAD',
  IN_STORE_PICKUP: 'IN_STORE_PICKUP'
};

exports.PaymentMethod = exports.$Enums.PaymentMethod = {
  CASH: 'CASH',
  CARD: 'CARD'
};

exports.PaymentStatus = exports.$Enums.PaymentStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  SUCCESSFUL: 'SUCCESSFUL',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
  REFUNDED: 'REFUNDED',
  DISPUTED: 'DISPUTED',
  PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED',
  EXPIRED: 'EXPIRED',
  AUTHORISED: 'AUTHORISED'
};

exports.StockStatus = exports.$Enums.StockStatus = {
  IN_STOCK: 'IN_STOCK',
  OUT_OF_STOCK: 'OUT_OF_STOCK',
  LIMITED: 'LIMITED'
};

exports.ProductStatus = exports.$Enums.ProductStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED'
};

exports.AnimalType = exports.$Enums.AnimalType = {
  DOG: 'DOG',
  CAT: 'CAT',
  BIRD: 'BIRD',
  FISH: 'FISH',
  REPTILE: 'REPTILE',
  RODENT: 'RODENT',
  HORSE: 'HORSE',
  OTHER: 'OTHER'
};

exports.AgeGroup = exports.$Enums.AgeGroup = {
  PUPPY: 'PUPPY',
  ADULT: 'ADULT',
  SENIOR: 'SENIOR',
  ALL: 'ALL'
};

exports.AttributeType = exports.$Enums.AttributeType = {
  COLOR: 'COLOR',
  SIZE: 'SIZE',
  TEXT: 'TEXT',
  NUMBER: 'NUMBER',
  DROPDOWN: 'DROPDOWN'
};

exports.ReviewStatus = exports.$Enums.ReviewStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED'
};

exports.MediaType = exports.$Enums.MediaType = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  PDF: 'PDF',
  AR_MODEL: 'AR_MODEL'
};

exports.DocumentType = exports.$Enums.DocumentType = {
  MANUAL: 'MANUAL',
  FAQ: 'FAQ',
  INSTALLATION_GUIDE: 'INSTALLATION_GUIDE',
  WARRANTY_DOCUMENT: 'WARRANTY_DOCUMENT',
  OTHER: 'OTHER'
};

exports.FlagType = exports.$Enums.FlagType = {
  FEATURED: 'FEATURED',
  BEST_SELLER: 'BEST_SELLER',
  NEW_ARRIVAL: 'NEW_ARRIVAL',
  LIMITED_EDITION: 'LIMITED_EDITION',
  SALE: 'SALE'
};

exports.RuleType = exports.$Enums.RuleType = {
  MIN_QUANTITY: 'MIN_QUANTITY',
  MAX_QUANTITY: 'MAX_QUANTITY',
  REQUIRED_PRODUCT: 'REQUIRED_PRODUCT',
  EXCLUSIVE_PRODUCT: 'EXCLUSIVE_PRODUCT'
};

exports.AutomationEvent = exports.$Enums.AutomationEvent = {
  STOCK_LOW: 'STOCK_LOW',
  ORDER_CREATED: 'ORDER_CREATED',
  ORDER_COMPLETED: 'ORDER_COMPLETED',
  ORDER_CANCELLED: 'ORDER_CANCELLED',
  CART_ABANDONED: 'CART_ABANDONED',
  USER_SIGNUP: 'USER_SIGNUP',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  SCHEDULED: 'SCHEDULED'
};

exports.AutomationField = exports.$Enums.AutomationField = {
  STOCK: 'STOCK',
  ORDER_TOTAL: 'ORDER_TOTAL',
  FAILED_ATTEMPTS: 'FAILED_ATTEMPTS',
  ITEMS_IN_CART: 'ITEMS_IN_CART',
  USER_REGISTRATION: 'USER_REGISTRATION'
};

exports.Operator = exports.$Enums.Operator = {
  LESS_THAN: 'LESS_THAN',
  GREATER_THAN: 'GREATER_THAN',
  EQUAL: 'EQUAL',
  NOT_EQUAL: 'NOT_EQUAL'
};

exports.AutomationActionType = exports.$Enums.AutomationActionType = {
  RESTOCK: 'RESTOCK',
  SEND_EMAIL: 'SEND_EMAIL',
  APPLY_DISCOUNT: 'APPLY_DISCOUNT',
  NOTIFY_ADMIN: 'NOTIFY_ADMIN',
  GENERATE_REPORT: 'GENERATE_REPORT',
  FLAG_SUSPICIOUS_ACTIVITY: 'FLAG_SUSPICIOUS_ACTIVITY',
  ADD_LOYALTY_POINTS: 'ADD_LOYALTY_POINTS'
};

exports.ScheduleFrequency = exports.$Enums.ScheduleFrequency = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  CUSTOM: 'CUSTOM'
};

exports.SubscriptionStatus = exports.$Enums.SubscriptionStatus = {
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED',
  COMPLETED: 'COMPLETED'
};

exports.SubscriptionFrequency = exports.$Enums.SubscriptionFrequency = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  BI_WEEKLY: 'BI_WEEKLY',
  MONTHLY: 'MONTHLY'
};

exports.Prisma.ModelName = {
  User: 'User',
  Address: 'Address',
  Activity: 'Activity',
  Notification: 'Notification',
  AdminNotification: 'AdminNotification',
  Order: 'Order',
  OrderItem: 'OrderItem',
  OrderItemAttributeValue: 'OrderItemAttributeValue',
  Cart: 'Cart',
  CartItem: 'CartItem',
  CartItemAttributeValue: 'CartItemAttributeValue',
  Payment: 'Payment',
  WebsiteSettings: 'WebsiteSettings',
  Product: 'Product',
  ProductCategory: 'ProductCategory',
  Variant: 'Variant',
  Attribute: 'Attribute',
  AttributeValue: 'AttributeValue',
  Image: 'Image',
  Video: 'Video',
  Rating: 'Rating',
  Question: 'Question',
  BulkDiscount: 'BulkDiscount',
  RegionalPricing: 'RegionalPricing',
  RegionalAvailability: 'RegionalAvailability',
  Compliance: 'Compliance',
  Bundle: 'Bundle',
  BundleItem: 'BundleItem',
  PriceHistory: 'PriceHistory',
  Media: 'Media',
  SupportDocument: 'SupportDocument',
  DiscountCode: 'DiscountCode',
  ProductFlag: 'ProductFlag',
  ProductFlagProduct: 'ProductFlagProduct',
  RecommendedProduct: 'RecommendedProduct',
  Wishlist: 'Wishlist',
  WishlistItem: 'WishlistItem',
  BundleRule: 'BundleRule',
  CrossBorderConstraint: 'CrossBorderConstraint',
  ProductDiscount: 'ProductDiscount',
  Category: 'Category',
  Popularity: 'Popularity',
  PopularSection: 'PopularSection',
  PopularSectionProduct: 'PopularSectionProduct',
  AutomationRule: 'AutomationRule',
  AutomationEventTrigger: 'AutomationEventTrigger',
  AutomationCondition: 'AutomationCondition',
  AutomationAction: 'AutomationAction',
  AutomationActionParameter: 'AutomationActionParameter',
  ScheduledAutomation: 'ScheduledAutomation',
  MarketingPreference: 'MarketingPreference',
  Brand: 'Brand',
  BankCard: 'BankCard',
  AutoshipSubscription: 'AutoshipSubscription',
  AutoshipSubscriptionItem: 'AutoshipSubscriptionItem'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
